"use client";
import { Collection } from "@/api/collections/types";
import { CancelOfferButton } from "../../Trade/Buttons/CancelOffer";
import { MakeCollectionOfferButton } from "../../Trade/Buttons/MakeCollectionOffer";
import ordersApi from "@/api/orders/client";
import { useQuery } from "@tanstack/react-query";
import useMe from "@/shared/hooks/useMe";

export interface Props {
  collection: Collection;
}

export default function CollectionOfferButton({ collection }: Props) {
  const { me } = useMe();

  const { data: offer } = useQuery({
    queryKey: ["collection-offer", collection.address, me?.address],
    queryFn: () => ordersApi.getCollectionOfferForBidder(collection.address),
    enabled: !!me,
  });

  if (!me) return null;

  return !offer ? (
    <MakeCollectionOfferButton collection={collection} />
  ) : (
    <CancelOfferButton
      className="self-center lg:absolute top-[500px] right-0 mt-6 lg:mt-0"
      title="Cancel collection offer"
      collection={collection}
      offer={offer}
    />
  );
}
